import { Link, useOutletContext, useParams } from 'react-router-dom';
import type { GameHubContext } from './GameHub.js';

/** Übersicht des gewählten Trophy Sets. Nur echte Setdaten, nichts Erfundenes. */
export function GameOverview() {
  const { game, set } = useOutletContext<GameHubContext>();
  const { gameId, trophySetId } = useParams();

  return (
    <>
      <div className="ph-card">
        <div className="ph-section__head">
          <h2 className="ph-section__title ph-section__title--account">Diese Version</h2>
          <span className="ph-badge">{set.supportState}</span>
        </div>
        <div className="ph-kv">
          <span className="ph-kv__key">Plattform</span>
          <span className="ph-kv__value">{set.platform.toUpperCase()}</span>
        </div>
        <div className="ph-kv">
          <span className="ph-kv__key">Region</span>
          <span className="ph-kv__value">{set.region.toUpperCase()}</span>
        </div>
        <div className="ph-kv">
          <span className="ph-kv__key">Version</span>
          <span className="ph-kv__value">{set.version ?? '–'}</span>
        </div>
        <div className="ph-kv">
          <span className="ph-kv__key">Platin</span>
          <span className="ph-kv__value">{set.hasPlatinum ? 'ja' : 'nein'}</span>
        </div>
      </div>

      <div className="ph-card">
        <div className="ph-section__head">
          <h2 className="ph-section__title ph-section__title--psn">Dein Fortschritt</h2>
          <span className="ph-badge ph-badge--off">nicht verknüpft</span>
        </div>
        <p className="ph-muted">
          Der Earned State kommt aus dem PSN-Sync und hängt immer an genau dieser Version. Solange
          kein PSN-Konto verknüpft ist, zeigt PlatHunt hier keinen Fortschritt an.
        </p>
      </div>

      <div className="ph-card">
        <Link className="ph-row" to={`/game/${gameId}/set/${trophySetId}/trophies`}>
          Trophäen
          <div className="ph-muted">{set.trophyCount.total} in dieser Version</div>
        </Link>
        {game && (
          <Link className="ph-row" to={`/game/${gameId}`}>
            Andere Versionen
            <div className="ph-muted">Plattform oder Region wechseln</div>
          </Link>
        )}
      </div>
    </>
  );
}
